import axios, { AxiosError } from "axios";
import qs from "qs";

const handleResponseError = (error: AxiosError) => {
	if (error.response?.status === 403) {
		// O ideal aqui seria usar o `navigate` do `react-router-dom` para uma melhor experiência do usuário,
		// mas como estamos fora de um componente React, usamos `window.location.href` que força um reload da página.
		// Para uma implementação mais elegante, pode-se usar um event emitter ou um history object customizado.
		localStorage.removeItem("access-token");
		window.location.href = '/login';
	}
	return Promise.reject(error);
};

export const useBack = () => {

	const instance = axios.create({
		baseURL: '/api',
		headers: {
			"Content-Type": "application/json",
		},
		paramsSerializer: {
			serialize: params => qs.stringify(params, { arrayFormat: "repeat" }),
		},
	});

	instance.interceptors.request.use(
		(config) => {
			const token = localStorage.getItem("access-token");
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		response => response, handleResponseError
	);

	return instance;
};

export const useBackMultipart = () => {

	const instance = axios.create({
		baseURL: '/api',
		headers: {
			"Content-Type": "multipart/form-data",
		},
		paramsSerializer: {
			serialize: params => qs.stringify(params, { arrayFormat: "repeat" }),
		},
	});

	instance.interceptors.request.use(
		(config) => {
			const token = localStorage.getItem("access-token");
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		response => response, handleResponseError
	);

	return instance;
};